import { Button, ButtonProps } from '@/components/ui/button';
import { AdvancedGeneratorIcon, CloseFilledIcon } from '@/components/Icons';
import { cn } from '@/utils';
import React from 'react';
import Show from '@/components/Show';

interface EffectsButtonProps extends ButtonProps {
  className?: string;
}

const EffectsButton: React.FC<EffectsButtonProps> = ({ className, ...props }) => {
  return (
    <Button
      {...props}
      className={cn(
        'flex flex-col items-center justify-center w-[210px] h-16 rounded-lg shadow-lg p-4 mr-2 transition-opacity duration-200 opacity-90 hover:opacity-100',
        className,
      )}
      style={{
        background: 'linear-gradient(#383A3C, #2B2E30)',
        border: '1px solid #474A4C',
        boxShadow: '2px 2px 10px rgba(0, 0, 0, 1)',
      }}
    >
      <div>
        <AdvancedGeneratorIcon className="mb-2 hover:text-white transition-colors duration-300" />
        <span className="font-pressura-mono text-gray-300 text-lg tracking-wider hover:text-white transition-colors duration-300">
          ADVANCED JENERATOR
        </span>
      </div>
    </Button>
  );
};

export const MobileEffectsButton: React.FC<EffectsButtonProps & { open: boolean }> = ({ className, open, ...props }) => {
  return (
    <Button
      {...props}
      className={cn(
        'flex flex-col items-center justify-center w-20 h-20 p-4 rounded-none transition-opacity duration-200 opacity-90 hover:opacity-100',
        className,
      )}
      style={{
        background: 'linear-gradient(#383A3C, #2B2E30)',
      }}
    >
      <Show when={open}>
        <CloseFilledIcon fillColor={'#9D9DA6'} />
      </Show>
      <Show when={!open}>
        <AdvancedGeneratorIcon className="mb-2 hover:text-white transition-colors duration-300" />
      </Show>
    </Button>
  );
};

export default EffectsButton;
